<loading-indicator [show]="!formReady || saving"></loading-indicator>

<div [formGroup]="formData" class="generatedHTMLWindow generatedHTMLForm angularForm" *ngIf="formReady">
  <div class="formHeader">
    <span class="navigateBtn navigate-left" (click)="previous()" *ngIf="showPrevBtn && currentOid > 0">
      <svg-icon title="{{'navigation.previous' | translate | uppercase}}" src='./assets/icons/play.svg'></svg-icon>
    </span>
    <span class="headerTitle">{{ 'comparablesValuation.valuationDetails' | translate }}</span>
    <span class="navigateBtn navigate-right" (click)="next()" *ngIf="showNextBtn && currentOid > 0">
      <svg-icon title="{{'navigation.next' | translate | uppercase}}" src='./assets/icons/play.svg'></svg-icon>
    </span>
  </div>
  <div class="generatedHTMLRoot">
    <div class="mainSection">
      <div class="section" style="width: 50%">
        <div class="sectionTitleContainer">
          <span class="sectionTitle">VALUATION INFORMATION</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.Region' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="Region" kendoTextBox id="form-Region" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.Sector' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="Sector" kendoTextBox id="form-Sector" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.EntityId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="EntityId" kendoTextBox id="form-EntityId" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.PreparerName' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="PreparerName" kendoTextBox id="form-PreparerName" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.TotalArea' | translate }} | {{unitOfLength}}²</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="TotalArea" format="n2" [spinners]="false" id="form-TotalArea"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.GrossValue' | translate }} | {{currency}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="GrossValue" format="n2" [spinners]="false" id="form-GrossValue"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.NetValue' | translate }} | {{currency}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="NetValue" format="n2" [spinners]="false" id="form-NetValue"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.SayValue' | translate }} | {{currency}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="SayValue" format="n2" [spinners]="false" id="form-SayValue"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.InitialYield' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="InitialYield" format="n2" [spinners]="false" id="form-InitialYield"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.ReversionaryYield' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="ReversionaryYield" format="n2" [spinners]="false" id="form-ReversionaryYield"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.NetRent' | translate }} | {{currency}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="NetRent" format="n2" [spinners]="false" id="form-NetRent"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent" *ngIf="formData.controls['NoOfTenants'] as NoOfTenants">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.NoOfTenants' | translate }}</span>
                  <span *ngIf="NoOfTenants.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="NoOfTenants.invalid">
                  <kendo-numerictextbox formControlName="NoOfTenants" format="n0" [spinners]="false" id="form-NoOfTenants"></kendo-numerictextbox>
                </div>
              </div>

              <div class="field width50percent" *ngIf="formData.controls['numberOfInternalParkingPlaces'] as numberOfInternalParkingPlaces">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.numberOfInternalParkingPlaces' | translate }}</span>
                  <span *ngIf="numberOfInternalParkingPlaces.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="numberOfInternalParkingPlaces.invalid">
                  <kendo-numerictextbox formControlName="numberOfInternalParkingPlaces" format="n0" [spinners]="false" id="form-numberOfInternalParkingPlaces"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent" *ngIf="formData.controls['numberOfExternalParkingPlaces'] as numberOfExternalParkingPlaces">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.numberOfExternalParkingPlaces' | translate }}</span>
                  <span *ngIf="numberOfExternalParkingPlaces.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="numberOfExternalParkingPlaces.invalid">
                  <kendo-numerictextbox formControlName="numberOfExternalParkingPlaces" format="n0" [spinners]="false" id="form-numberOfExternalParkingPlaces"></kendo-numerictextbox>
                </div>
              </div>

              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.nursingHomeTotal' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="nursingHomeTotal" format="n0" [spinners]="false" id="form-nursingHomeTotal"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent" *ngIf="formData.controls['nursingHomeSingleRooms'] as nursingHomeSingleRooms">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.nursingHomeSingleRooms' | translate }}</span>
                  <span *ngIf="nursingHomeSingleRooms.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="nursingHomeSingleRooms.invalid">
                  <kendo-numerictextbox formControlName="nursingHomeSingleRooms" format="n0" [spinners]="false" id="form-nursingHomeSingleRooms"></kendo-numerictextbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section" style="width: 50%">
        <div class="sectionTitleContainer noBorder">
          <span class="sectionTitle">&nbsp;</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">

              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.PrimaryUse' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="PrimaryUse" kendoTextBox id="form-PrimaryUse" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.PropFileRefNo' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="PropFileRefNo" kendoTextBox id="form-PropFileRefNo" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.PercentEquity' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PercentEquity" format="n2" [spinners]="false" id="form-PercentEquity"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.PropertyIrr' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PropertyIrr" format="n2" [spinners]="false" id="form-PropertyIrr"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.CapitalCosts' | translate }} | {{currency}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="CapitalCosts" format="n2" [spinners]="false" id="form-CapitalCosts"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.AcquisitionCosts' | translate }} | {{currency}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="AcquisitionCosts" format="n2" [spinners]="false" id="form-AcquisitionCosts"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.EquivalentYield' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="EquivalentYield" format="n2" [spinners]="false" id="form-EquivalentYield"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.TrueEquivalentYield' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="TrueEquivalentYield" format="n2" [spinners]="false" id="form-TrueEquivalentYield"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.GrossRent' | translate }} | {{currency}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="GrossRent" format="n2" [spinners]="false" id="form-GrossRent"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.GrossRentalValue' | translate }} | {{currency}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="GrossRentalValue" format="n2" [spinners]="false" id="form-GrossRentalValue"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.CurrencyCode' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="CurrencyCode" kendoTextBox id="form-CurrencyCode" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.CurrencyDescription' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="CurrencyDescription" kendoTextBox id="form-CurrencyDescription" />
                </div>
              </div>

              <div class="field width50percent" *ngIf="formData.controls['totalNumberOfParkingPlaces'] as totalNumberOfParkingPlaces">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.totalNumberOfParkingPlaces' | translate }}</span>
                  <span *ngIf="totalNumberOfParkingPlaces.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="totalNumberOfParkingPlaces.invalid">
                  <kendo-numerictextbox formControlName="totalNumberOfParkingPlaces" format="n0" [spinners]="false" id="form-totalNumberOfParkingPlaces"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent" *ngIf="formData.controls['residentialUnits'] as residentialUnits">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.residentialUnits' | translate }}</span>
                  <span *ngIf="residentialUnits.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="residentialUnits.invalid">
                  <kendo-numerictextbox formControlName="residentialUnits" format="n0" [spinners]="false" id="form-residentialUnits"></kendo-numerictextbox>
                </div>
              </div>

              <div class="field width50percent" *ngIf="formData.controls['nursingHomeDoubleRooms'] as nursingHomeDoubleRooms">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.nursingHomeDoubleRooms' | translate }}</span>
                  <span *ngIf="nursingHomeDoubleRooms.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="nursingHomeDoubleRooms.invalid">
                  <kendo-numerictextbox formControlName="nursingHomeDoubleRooms" format="n0" [spinners]="false" id="form-nursingHomeDoubleRooms"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent" *ngIf="formData.controls['hotelNumberOfRooms'] as hotelNumberOfRooms">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.hotelNumberOfRooms' | translate }}</span>
                  <span *ngIf="hotelNumberOfRooms.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="hotelNumberOfRooms.invalid">
                  <kendo-numerictextbox formControlName="hotelNumberOfRooms" format="n0" [spinners]="false" id="form-hotelNumberOfRooms"></kendo-numerictextbox>
                </div>
              </div>

              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.unitOfLength' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="unitOfLengthId"
                                      [data]="reflistData.ref_unit_of_length"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      (ngModelChange)="onUnitOfLengthChanged($event)"
                                      id="form-unitOfLengthId">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.currency' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="currencyId"
                                      [data]="reflistData.ref_currency_with_code"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      (ngModelChange)="onCurrencyChanged($event)"
                                      id="form-currencyId">
                  </kendo-dropdownlist>
                </div>
              </div>
            </div>
          </div>
          <div class="invisibleSection" style="width: 50%">
          </div>
        </div>
      </div>
      <div class="section" style="width: 50%">
        <div class="sectionTitleContainer">
          <span class="sectionTitle">PROJECT / SYSTEM INFORMATION</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.projectPuid' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="projectPuid"
                                      #projectRetriever
                                      [data]="retrieverData.Project"
                                      textField="projectName"
                                      [filterable]="true"
                                      valueField="id"
                                      [valuePrimitive]="true"
                                      (ngModelChange)="onProjectSelected()"
                                      id="form-projectPUID">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.valuationPortfolio' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="valuationId"
                                      #valuationEventRetriever
                                      [data]="retrieverData.ValuationPortfolio"
                                      textField="ValuationPortfolioName"
                                      [filterable]="true"
                                      valueField="id"
                                      [valuePrimitive]="true"
                                      (ngModelChange)="onValuationEventSelected()"
                                      id="form-valuationId">
                  </kendo-dropdownlist>
                </div>
              </div>

              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.createdAt' | translate }}</span>
                </div>
                <div class="fieldContainer">

                  <kendo-datepicker formControlName="createdAt" id="form-createdAt"></kendo-datepicker>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.createdBy' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="createdBy"
                                      [data]="reflistData.config_user"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-createdBy">
                  </kendo-dropdownlist>
                </div>
              </div>

              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.ownerBuId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="OwnerBuId"
                                      [data]="reflistData.config_business_units"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-OwnerBuId">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.modifiedAt' | translate }}</span>
                </div>
                <div class="fieldContainer">

                  <kendo-datepicker formControlName="modifiedAt" id="form-modifiedAt"></kendo-datepicker>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.modifiedBy' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="modifiedBy"
                                      [data]="reflistData.config_user"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-modifiedBy">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                &nbsp; <!-- No modifier BU-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section" style="width: 50%">
        <div class="sectionTitleContainer">
          <span class="sectionTitle">PROPERTY INFORMATION</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.propertyID' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="propertyID"
                                      #propertyRetriever
                                      [data]="retrieverData.Property"
                                      textField="description"
                                      [filterable]="true"
                                      valueField="OID"
                                      [valuePrimitive]="true"
                                      (ngModelChange)="onPropertySelected()"
                                      id="form-propertyID">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.propertyName' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="propertyName" kendoTextBox id="form-propertyName" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-propertyName" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.propertyType' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="propertyPrimaryUse" kendoTextBox id="form-propertyPrimaryUse" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-propertyPrimaryUse" />
                </div>
              </div>
              <div class="field width100percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.street' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="street" kendoTextBox id="form-street" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-street" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.numberFrom' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="numberFrom" kendoTextBox id="form-numberFrom" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-numberFrom" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.numberTo' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="numberTo" kendoTextBox id="form-numberTo" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-numberTo" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.numberAdd' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="numberAdd" kendoTextBox id="form-numberAdd" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-numberAdd" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.postCode' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="PostCode" kendoTextBox id="form-PostCode" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-PostCode" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.city' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="city" kendoTextBox id="form-city" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-city" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.region' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="propertyRegion" kendoTextBox id="form-propertyRegion" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-propertyRegion" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.subMarket' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="SubMarket" kendoTextBox id="form-SubMarket" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-SubMarket" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.country' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="Country" kendoTextBox id="form-Country" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-Country" />
                </div>
              </div>
              <div class="field width33percent"><div class="labelContainer emptyLabel"></div><div class="fieldContainer emptyField"></div></div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.constructionYear' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="constructionYear" kendoTextBox id="form-constructionYear" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-constructionYear" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.renovationYear' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="renovationYear" kendoTextBox id="form-renovationYear" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-renovationYear" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.energyLabel' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="energyLabelDescription" kendoTextBox id="form-energyLabelDescription" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-energyLabelDescription" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
